import { render, staticRenderFns } from "./LoginHeaderSection.vue?vue&type=template&id=37d223e0&scoped=true"
import script from "./LoginHeaderSection.vue?vue&type=script&lang=ts"
export * from "./LoginHeaderSection.vue?vue&type=script&lang=ts"
import style0 from "./LoginHeaderSection.vue?vue&type=style&index=0&id=37d223e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d223e0",
  null
  
)

export default component.exports